import {
  Component,
  DestroyRef,
  inject,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import {
  AwButtonIconOnlyDirective,
  AwDatePickerComponent,
  AwFormFieldLabelComponent,
  AwFormFieldComponent,
  AwFormMessageComponent,
} from '@assetworks-llc/aw-component-lib';

@Component({
    selector: 'app-aw-date-form',
    imports: [
        AwFormFieldComponent,
        AwFormFieldLabelComponent,
        AwFormMessageComponent,
        ReactiveFormsModule,
        AwButtonIconOnlyDirective,
        MatIconModule,
        FormsModule,
        AwDatePickerComponent,
        MatTabsModule,
    ],
    templateUrl: './aw-date-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './aw-date-form.component.scss'
})
export class AwDateFormComponent {
  title = input<string>('');
  subtitle = input<string>('');
  required = input<boolean>(false);

  dateSelected = output<Date | null>();

  placeholder = input<string>('Select Date');
  multiDatePicker = input<boolean>(false);

  datePickerForm = new FormGroup({
    date: new FormControl<Date | null>(null),
  });

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    // Only a required date gets the validator. An optional one (a table filter) cleared back to empty is valid, so it
    // shows its placeholder rather than CCL's red error outline.
    if (this.required()) {
      this.datePickerForm.controls['date'].addValidators(Validators.required);
    }
    this.datePickerForm.controls['date'].valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((newDate) => {
        this.dateSelected.emit(newDate);
      });
  }
}
